import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { ENDPOINTS, USER_ROLES } from '../app.config';
import Utils from '../app.utilities';

const utilities = new Utils();

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers : [Utils]
})
export class LoginComponent implements OnInit {
  email: string;
  emailInvalid: boolean;
  password: string;
  passwordInvalid: boolean;
  router: Router;
  toaster: ToasterService;

  constructor(router: Router, toaster: ToasterService, private utils:Utils) {
    this.email = this.password = '';
    this.emailInvalid = this.passwordInvalid = false;
    this.router = router;
    this.toaster = toaster;
  }

  ngOnInit() {
    const tokenExists = !!utilities.getStorage('token');
    if (tokenExists) {
      this.router.navigate(['owners']);
    }
  }

  validateLoginInformation() {
    this.emailInvalid = this.passwordInvalid = false;
    if (this.email === '') {
      this.emailInvalid = true;
    }
    if (this.password === '') {
      this.passwordInvalid = true;
    }
    return !this.emailInvalid && !this.passwordInvalid;
  }

  login() {
    const loginInfoValid = this.validateLoginInformation();
    if (loginInfoValid) {
      const auth = { email: this.email, password: this.password };
      axios.post(ENDPOINTS.LOGIN, auth).then(
        response => {
          utilities.setStorage('token', response.data.auth_token);
          axios.get(ENDPOINTS.GET_CURRENT_USER).then(
            responseUser => {
              const loggedUser = responseUser.data;
              const homepage = utilities.getUserRoleHomepage(loggedUser);
              this.router.navigate([homepage]);
            }
          )
        },
        error => {
          this.toaster.pop(
            'error',
            error.response.data.message,
          );
        },
      );
    }
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      this.login();
    }
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/login/login.component.ts